import AddPostContainer from "../../../../Components/Miscellaneous/Blog/AddPost"

const AddPost = () => {
  return (
    <div className='page-body'>
      <AddPostContainer />
    </div>
  )
}

export default AddPost
